import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";
import { WHATSAPP_LINK } from "@/mocks/restaurant";
import WaveMark from "./WaveMark";

export default function Closing() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-background-100 py-16 md:py-24">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center md:px-10">
        <Reveal className="flex flex-col items-center">
          <WaveMark className="mb-8 h-8 w-24" />
          <h2 className="font-heading text-3xl leading-tight text-foreground-50 md:text-5xl">
            {t("closing.title")}
          </h2>
          <p className="mt-4 font-body text-base text-secondary-500 md:text-lg">
            {t("closing.text")}
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="press mt-8 inline-flex min-h-[52px] w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-4 font-body text-base text-foreground-950 transition-colors hover:bg-primary-600 cursor-pointer sm:w-auto"
          >
            <i className="ri-whatsapp-fill text-xl" aria-hidden="true" />
            {t("closing.cta")}
          </a>
        </Reveal>
      </div>
    </section>
  );
}